import { usePostTrackEventWithParams } from "./analyticsQueries"

export type TDashboardNoiseInsightsEventTypes = "View Analytics Clicked"

function usePostDashboardNoiseInsightsTrackingEvent<TEventProperties>(
  event: TDashboardNoiseInsightsEventTypes
) {
  return usePostTrackEventWithParams<
    TDashboardNoiseInsightsEventTypes,
    TEventProperties
  >({
    event,
  })
}

export function usePostDashboardNoiseInsightsViewAnalyticsClicked() {
  const x = usePostDashboardNoiseInsightsTrackingEvent("View Analytics Clicked")
  return {
    ...x,
    mutate: () => x.mutate({}),
  }
}
